import { render, staticRenderFns } from "./CmgPillSelector.vue?vue&type=template&id=6935de3c&scoped=true&lang=pug&"
import script from "./cmg-pill-selector.ts?vue&type=script&lang=ts&"
export * from "./cmg-pill-selector.ts?vue&type=script&lang=ts&"
import style0 from "./CmgPillSelector.vue?vue&type=style&index=0&id=6935de3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6935de3c",
  null
  
)

export default component.exports